var _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgArrow = function SvgArrow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: ref,
    "aria-labelledby": titleId
  }), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.572694,
    width: 6.31847,
    height: 0.809912,
    rx: 0.404956,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 5.58876 9.30208)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.809912
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.99371,
    y: 1.92236,
    width: 6.31847,
    height: 0.809912,
    rx: 0.404956,
    transform: "rotate(135 5.99371 1.92236)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.809912
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrow);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;